import { tr } from "../../i18n";
import { useState } from "react";
import { Link, NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { ClipboardList, Mail, Users, LogOut, Menu, X, KeyRound } from "lucide-react";
import { useAuth } from "../../auth/AuthContext";
export default function AdminLayout() {
  const {
    lang = "en"
  } = useParams();
  const {
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const links = [{
    to: "eri",
    label: "ERI",
    icon: ClipboardList
  }, {
    to: "mail",
    label: "Mail",
    icon: Mail
  }, {
    to: "clients",
    label: "Clients",
    icon: Users
  }];
  const doLogout = async () => {
    await logout();
    navigate(`/${lang}/login`);
  };
  const nav = <nav className="flex flex-1 flex-col gap-1 px-4 py-6" aria-label={tr("Admin")}>
      {links.map(l => <NavLink key={l.to} to={`/${lang}/admin/${l.to}`} onClick={() => setOpen(false)} data-testid={`admin-nav-${l.to}`} className={({
      isActive
    }) => `flex items-center gap-3 border-l-2 px-4 py-2.5 text-sm transition-colors ${isActive ? "border-esaia-blue bg-esaia-blue/5 font-semibold text-esaia-blue" : "border-transparent text-esaia-muted hover:bg-esaia-surface hover:text-esaia-ink"}`}>
          <l.icon size={17} strokeWidth={1.7} />
          {tr(l.label)}
        </NavLink>)}
    </nav>;
  return <div className="flex min-h-screen bg-esaia-canvas" data-testid="admin-portal">
      <aside className="hidden w-60 shrink-0 flex-col border-r border-esaia-line bg-white lg:flex">
        <div className="border-b border-esaia-line px-6 py-5">
          <Link to={`/${lang}`}>
            <img src="/logo.png" alt={tr("ESAIA")} className="h-9 w-auto" />
          </Link>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-esaia-subtle">{tr("Admin Portal")}</p>
        </div>
        {nav}
        <div className="space-y-1 border-t border-esaia-line p-4">
          <Link to={`/${lang}/change-password`} data-testid="admin-change-password" className="flex items-center gap-3 px-4 py-2.5 text-sm text-esaia-muted transition-colors hover:text-esaia-ink">
            <KeyRound size={16} strokeWidth={1.7} />{" "}{tr("Change Password")}{" "}</Link>
          <button onClick={doLogout} data-testid="admin-logout-button" className="flex w-full items-center gap-3 px-4 py-2.5 text-sm text-esaia-muted transition-colors hover:text-red-600">
            <LogOut size={16} strokeWidth={1.7} />{" "}{tr("Log Out")}{" "}</button>
        </div>
      </aside>

      <div className="flex min-h-screen flex-1 flex-col">
        <div className="flex items-center justify-between border-b border-esaia-line bg-white px-4 py-3 lg:hidden">
          <img src="/logo.png" alt={tr("ESAIA")} className="h-8 w-auto" />
          <button onClick={() => setOpen(!open)} aria-label={tr("Menu")} className="text-esaia-ink" data-testid="admin-mobile-menu-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {open && <div className="border-b border-esaia-line bg-white lg:hidden">
            {nav}
            <div className="space-y-1 border-t border-esaia-line p-4">
              <Link to={`/${lang}/change-password`} className="flex items-center gap-3 px-4 py-2 text-sm text-esaia-muted">
                <KeyRound size={16} />{" "}{tr("Change Password")}{" "}</Link>
              <button onClick={doLogout} className="flex items-center gap-3 px-4 py-2 text-sm text-esaia-muted">
                <LogOut size={16} />{" "}{tr("Log Out")}{" "}</button>
            </div>
          </div>}

        <div className="hidden items-center justify-end gap-3 border-b border-esaia-line bg-white px-8 py-3.5 lg:flex">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-esaia-subtle">{tr("Administrator")}</span>
          <span className="text-sm font-medium text-esaia-ink" data-testid="admin-account-email">{user?.email}</span>
        </div>

        <main className="flex-1 px-4 py-8 sm:px-8 lg:px-10">
          <Outlet />
        </main>
      </div>
    </div>;
}
